!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/shortcode"] = t() : (e.wp = e.wp || {}, e.wp.shortcode = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      593: function _(e) {
        e.exports = function memize(e, t) {
          var r,
              n,
              s = 0;

          function memoized() {
            var o,
                i,
                a = r,
                c = arguments.length;

            e: for (; a;) {
              if (a.args.length === arguments.length) {
                for (i = 0; i < c; i++) {
                  if (a.args[i] !== arguments[i]) {
                    a = a.next;
                    continue e;
                  }
                }

                return a !== r && (a === n && (n = a.prev), a.prev.next = a.next, a.next && (a.next.prev = a.prev), a.next = r, a.prev = null, r.prev = a, r = a), a.val;
              }

              a = a.next;
            }

            for (o = new Array(c), i = 0; i < c; i++) {
              o[i] = arguments[i];
            }

            return a = {
              args: o,
              val: e.apply(null, o)
            }, r ? (r.prev = a, a.next = r) : n = a, s === t.maxSize ? (n = n.prev).next = null : s++, r = a, a.val;
          }

          return t = t || {}, memoized.clear = function () {
            r = null, n = null, s = 0;
          }, memoized;
        };
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var s = t[r] = {
        exports: {}
      };
      return e[r](s, s.exports, __webpack_require__), s.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = e.attrs = void 0, e.fromMatch = fromMatch, e.next = next, e.regexp = regexp, e.replace = replace, e.string = string;

      var n = __webpack_require__(793);

      function next(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        var n = regexp(e);
        n.lastIndex = r;
        var s = n.exec(t);
        if (!s) return;
        if ("[" === s[1] && "]" === s[7]) return next(e, t, n.lastIndex);
        var o = {
          index: s.index,
          content: s[0],
          shortcode: fromMatch(s)
        };
        return s[1] && (o.content = o.content.slice(1), o.index++), s[7] && (o.content = o.content.slice(0, -1)), o;
      }

      function replace(e, t, r) {
        return t.replace(regexp(e), function (e, t, n, s, o, i, a, c) {
          if ("[" === t && "]" === c) return e;
          var u = r(fromMatch(arguments));
          return u || "" === u ? t + u + c : e;
        });
      }

      function string(e) {
        return new o(e).string();
      }

      function regexp(e) {
        return new RegExp("\\[(\\[?)(" + e + ")(?![\\w-])([^\\]\\/]*(?:\\/(?!\\])[^\\]\\/]*)*?)(?:(\\/)\\]|\\](?:([^\\[]*(?:\\[(?!\\/\\2\\])[^\\[]*)*)(\\[\\/\\2\\]))?)(\\]?)", "g");
      }

      var s = (0, t(__webpack_require__(593)).default)(function (e) {
        var t = {},
            r = [],
            n = /([\w-]+)\s*=\s*"([^"]*)"(?:\s|$)|([\w-]+)\s*=\s*'([^']*)'(?:\s|$)|([\w-]+)\s*=\s*([^\s'"]+)(?:\s|$)|"([^"]*)"(?:\s|$)|'([^']*)'(?:\s|$)|(\S+)(?:\s|$)/g;
        var s;

        for (e = e.replace(/[\u00a0\u200b]/g, " "); s = n.exec(e);) {
          s[1] ? t[s[1].toLowerCase()] = s[2] : s[3] ? t[s[3].toLowerCase()] = s[4] : s[5] ? t[s[5].toLowerCase()] = s[6] : s[7] ? r.push(s[7]) : s[8] ? r.push(s[8]) : s[9] && r.push(s[9]);
        }

        return {
          named: t,
          numeric: r
        };
      });

      function fromMatch(e) {
        var t;
        return t = e[4] ? "self-closing" : e[6] ? "closed" : "single", new o({
          tag: e[2],
          attrs: e[3],
          type: t,
          content: e[5]
        });
      }

      e.attrs = s;
      var o = (0, n.extend)(function (e) {
        var _this = this;

        (0, n.extend)(this, (0, n.pick)(e || {}, "tag", "attrs", "type", "content"));
        var t = this.attrs;
        this.attrs = {
          named: {},
          numeric: []
        }, t && ((0, n.isString)(t) ? this.attrs = s(t) : (0, n.isEqual)(Object.keys(t), ["named", "numeric"]) ? this.attrs = t : (0, n.forEach)(t, function (e, t) {
          _this.set(t, e);
        }));
      }, {
        next: next,
        replace: replace,
        string: string,
        regexp: regexp,
        attrs: s,
        fromMatch: fromMatch
      });
      (0, n.extend)(o.prototype, {
        get: function get(e) {
          return this.attrs[(0, n.isNumber)(e) ? "numeric" : "named"][e];
        },
        set: function set(e, t) {
          return this.attrs[(0, n.isNumber)(e) ? "numeric" : "named"][e] = t, this;
        },
        string: function string() {
          var e = "[" + this.tag;
          return (0, n.forEach)(this.attrs.numeric, function (t) {
            /\s/.test(t) ? e += ' "' + t + '"' : e += " " + t;
          }), (0, n.forEach)(this.attrs.named, function (t, r) {
            e += " " + r + '="' + t + '"';
          }), "single" === this.type ? e + "]" : "self-closing" === this.type ? e + " /]" : (e += "]", this.content && (e += this.content), e + "[/" + this.tag + "]");
        }
      });
      var i = o;
      e.default = i;
    }(), r;
  }();
});